/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Activity } from '../models/Activity';
import type { ActivityUpdate } from '../models/ActivityUpdate';
import type { APIKeyMinimal } from '../models/APIKeyMinimal';
import type { ApplyActionRequest } from '../models/ApplyActionRequest';
import type { ChatMessage } from '../models/ChatMessage';
import type { ChatRequest } from '../models/ChatRequest';
import type { CreateTableFromRequest } from '../models/CreateTableFromRequest';
import type { GenerateCheckSuggestionsRequest } from '../models/GenerateCheckSuggestionsRequest';
import type { Keywords } from '../models/Keywords';
import type { Page_Activity_ } from '../models/Page_Activity_';
import type { Page_Workflow_ } from '../models/Page_Workflow_';
import type { Project } from '../models/Project';
import type { ProjectCreate } from '../models/ProjectCreate';
import type { Request } from '../models/Request';
import type { RequestCreate } from '../models/RequestCreate';
import type { Response } from '../models/Response';
import type { ResponseCreate } from '../models/ResponseCreate';
import type { RunRequest } from '../models/RunRequest';
import type { RunWorkflowWithDataFromDbRequest } from '../models/RunWorkflowWithDataFromDbRequest';
import type { SecretInDB } from '../models/SecretInDB';
import type { Subscription } from '../models/Subscription';
import type { TableData } from '../models/TableData';
import type { TableDataCreate } from '../models/TableDataCreate';
import type { TableDataUpdate } from '../models/TableDataUpdate';
import type { TableMetadata } from '../models/TableMetadata';
import type { TableMetadataCreate } from '../models/TableMetadataCreate';
import type { TableMetadataUpdate } from '../models/TableMetadataUpdate';
import type { Workflow } from '../models/Workflow';
import type { WorkflowCreate } from '../models/WorkflowCreate';
import type { WorkflowData } from '../models/WorkflowData';
import type { WorkflowDataChange } from '../models/WorkflowDataChange';
import type { WorkflowDataCreate } from '../models/WorkflowDataCreate';
import type { WorkflowDataUpdate } from '../models/WorkflowDataUpdate';
import type { WorkflowDataWithChanges } from '../models/WorkflowDataWithChanges';
import type { WorkflowExecution } from '../models/WorkflowExecution';
import type { WorkflowExecutionCreate } from '../models/WorkflowExecutionCreate';
import type { WorkflowExecutionUpdate } from '../models/WorkflowExecutionUpdate';
import type { WorkflowRunData } from '../models/WorkflowRunData';
import type { WorkflowUpdate } from '../models/WorkflowUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DefaultService {
    /**
     * Create Secret
     * @param secret
     * @param requestBody
     * @returns SecretInDB Successful Response
     * @throws ApiError
     */
    public static createSecret(
        secret: string,
        requestBody: Record<string, any>,
    ): CancelablePromise<SecretInDB> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/secrets/',
            query: {
                'secret': secret,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read Secret
     * Reads only the database part of the secret, not the actual value.
     * @param secretId
     * @returns SecretInDB Successful Response
     * @throws ApiError
     */
    public static readSecret(
        secretId: string,
    ): CancelablePromise<SecretInDB> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/secrets/{secret_id}',
            path: {
                'secret_id': secretId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Secret
     * @param secretId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteSecret(
        secretId: string,
    ): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/secrets/{secret_id}',
            path: {
                'secret_id': secretId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read Secrets By Org
     * Reads only the database part of the secret, not the actual value.
     * @returns SecretInDB Successful Response
     * @throws ApiError
     */
    public static readSecretsByOrg(): CancelablePromise<Array<SecretInDB>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/secrets/by_org/',
        });
    }
    /**
     * Read Secret By Org And Name
     * Reads only the database part of the secret, not the actual value.
     * @param name
     * @returns SecretInDB Successful Response
     * @throws ApiError
     */
    public static readSecretByOrgAndName(
        name: string,
    ): CancelablePromise<Array<SecretInDB>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/secrets/by_org_and_name/',
            query: {
                'name': name,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Api Key
     * @returns string Successful Response
     * @throws ApiError
     */
    public static generateApiKey(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api_keys/',
        });
    }
    /**
     * Read Api Keys For Org
     * @returns APIKeyMinimal Successful Response
     * @throws ApiError
     */
    public static readApiKeysForOrg(): CancelablePromise<Array<APIKeyMinimal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api_keys/by_org/',
        });
    }
    /**
     * Delete Api Key
     * @param keyId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteApiKey(
        keyId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api_keys/{key_id}',
            path: {
                'key_id': keyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Loops Contact
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createLoopsContact(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/loops/contact',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Receive Clerk Event
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static receiveClerkEvent(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/loops/clerk_event',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Subscription
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createSubscription(
        requestBody: Subscription,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payment/create_subscription',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Stripe Webhook
     * @returns any Successful Response
     * @throws ApiError
     */
    public static stripeWebhook(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payment/webhook',
        });
    }
    /**
     * Get Auth Url
     * @param tool
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getAuthUrl(
        tool: 'gmail' | 'googlesheets' | 'slack',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tools/auth_url',
            query: {
                'tool': tool,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Tool Action
     * @param tool
     * @param action
     * @returns any Successful Response
     * @throws ApiError
     */
    public static runToolAction(
        tool: 'gmail' | 'googlesheets' | 'slack',
        action: 'enable' | 'disable' | 'delete',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tools/action',
            query: {
                'tool': tool,
                'action': action,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Connections
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getConnections(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tools/connections',
        });
    }
    /**
     * Create Workflow
     * @param requestBody
     * @returns Workflow Successful Response
     * @throws ApiError
     */
    public static createWorkflow(
        requestBody: WorkflowCreate,
    ): CancelablePromise<Workflow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workflows/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Workflow
     * @param workflowId
     * @returns Workflow Successful Response
     * @throws ApiError
     */
    public static getWorkflow(
        workflowId: string,
    ): CancelablePromise<Workflow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/workflows/{workflow_id}',
            path: {
                'workflow_id': workflowId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Workflow
     * @param workflowId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteWorkflow(
        workflowId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/workflows/{workflow_id}',
            path: {
                'workflow_id': workflowId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Workflows By Org Paginate
     * @param page Page number
     * @param size Page size
     * @returns Page_Workflow_ Successful Response
     * @throws ApiError
     */
    public static getWorkflowsByOrgPaginate(
        page: number = 1,
        size: number = 50,
    ): CancelablePromise<Page_Workflow_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workflows/by_org_paginate/',
            query: {
                'page': page,
                'size': size,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Workflows By Org
     * @returns Workflow Successful Response
     * @throws ApiError
     */
    public static getWorkflowsByOrg(): CancelablePromise<Array<Workflow>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workflows/by_org/',
        });
    }
    /**
     * Update Workflow
     * @param workflowId
     * @param requestBody
     * @returns Workflow Successful Response
     * @throws ApiError
     */
    public static updateWorkflow(
        workflowId: string,
        requestBody: WorkflowUpdate,
    ): CancelablePromise<Workflow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workflows/update/{workflow_id}',
            path: {
                'workflow_id': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Workflow Config
     * @param workflowId
     * @param requestBody
     * @returns Workflow Successful Response
     * @throws ApiError
     */
    public static updateWorkflowConfig(
        workflowId: string,
        requestBody: Record<string, any>,
    ): CancelablePromise<Workflow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workflows/update_config/{workflow_id}',
            path: {
                'workflow_id': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Workflow With Data
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static runWorkflowWithData(
        requestBody: WorkflowRunData,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workflows/run_workflow_with_data',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Workflow With Data From Db
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static runWorkflowWithDataFromDb(
        requestBody: RunWorkflowWithDataFromDbRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workflows/run_workflow_with_data_from_db',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Workflow All
     * @param workflowId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static runWorkflowAll(
        workflowId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workflows/run_workflow_all/{workflow_id}',
            path: {
                'workflow_id': workflowId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Check Suggestions
     * Generate suggestions for checks based on previous outputs and context.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static generateCheckSuggestions(
        requestBody: GenerateCheckSuggestionsRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workflows/generate_check_suggestions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Apply Workflow Action
     * Apply a single action to modify the workflow.
     * @param workflowId
     * @param requestBody
     * @returns Workflow Successful Response
     * @throws ApiError
     */
    public static applyWorkflowAction(
        workflowId: string,
        requestBody: ApplyActionRequest,
    ): CancelablePromise<Workflow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workflows/workflows/{workflow_id}/apply_action',
            path: {
                'workflow_id': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chat With Workflow
     * Process a chat message and return proposed actions.
     * @param workflowId
     * @param requestBody
     * @returns ChatMessage Successful Response
     * @throws ApiError
     */
    public static chatWithWorkflow(
        workflowId: string,
        requestBody: ChatRequest,
    ): CancelablePromise<ChatMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workflows/workflows/{workflow_id}/chat',
            path: {
                'workflow_id': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Workflow Data
     * @param requestBody
     * @returns WorkflowData Successful Response
     * @throws ApiError
     */
    public static createWorkflowData(
        requestBody: WorkflowDataCreate,
    ): CancelablePromise<WorkflowData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow_data/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Workflow Data
     * @param workflowDataId
     * @returns WorkflowDataWithChanges Successful Response
     * @throws ApiError
     */
    public static getWorkflowData(
        workflowDataId: string,
    ): CancelablePromise<WorkflowDataWithChanges> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflow_data/{workflow_data_id}',
            path: {
                'workflow_data_id': workflowDataId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Workflow Data By Workflow
     * @param workflowId
     * @returns WorkflowDataWithChanges Successful Response
     * @throws ApiError
     */
    public static getWorkflowDataByWorkflow(
        workflowId: string,
    ): CancelablePromise<Array<WorkflowDataWithChanges>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflow_data/by_workflow/',
            query: {
                'workflow_id': workflowId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Workflow Data
     * @param workflowDataId
     * @param requestBody
     * @returns WorkflowData Successful Response
     * @throws ApiError
     */
    public static updateWorkflowData(
        workflowDataId: string,
        requestBody: WorkflowDataUpdate,
    ): CancelablePromise<WorkflowData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow_data/update/{workflow_data_id}',
            path: {
                'workflow_data_id': workflowDataId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Workflow Data Field
     * @param workflowDataId
     * @param fieldName
     * @param fieldValue
     * @returns WorkflowData Successful Response
     * @throws ApiError
     */
    public static updateWorkflowDataField(
        workflowDataId: string,
        fieldName: string,
        fieldValue: string,
    ): CancelablePromise<WorkflowData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow_data/update_field/{workflow_data_id}',
            path: {
                'workflow_data_id': workflowDataId,
            },
            query: {
                'field_name': fieldName,
                'field_value': fieldValue,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Workflow Data
     * @param workflowDataId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteWorkflowData(
        workflowDataId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow_data/delete/{workflow_data_id}',
            path: {
                'workflow_data_id': workflowDataId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Workflow Data Changes
     * Get all changes for a workflow data entry.
     * @param workflowDataId
     * @returns WorkflowDataChange Successful Response
     * @throws ApiError
     */
    public static getWorkflowDataChanges(
        workflowDataId: string,
    ): CancelablePromise<Array<WorkflowDataChange>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflow_data/{workflow_data_id}/changes',
            path: {
                'workflow_data_id': workflowDataId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Workflow Execution
     * @param requestBody
     * @returns WorkflowExecution Successful Response
     * @throws ApiError
     */
    public static createWorkflowExecution(
        requestBody: WorkflowExecutionCreate,
    ): CancelablePromise<WorkflowExecution> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow_executions/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Workflow Execution
     * @param workflowExecutionId
     * @returns WorkflowExecution Successful Response
     * @throws ApiError
     */
    public static getWorkflowExecution(
        workflowExecutionId: string,
    ): CancelablePromise<WorkflowExecution> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflow_executions/{workflow_execution_id}',
            path: {
                'workflow_execution_id': workflowExecutionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Workflow Executions By Workflow
     * @param workflowId
     * @returns WorkflowExecution Successful Response
     * @throws ApiError
     */
    public static getWorkflowExecutionsByWorkflow(
        workflowId: string,
    ): CancelablePromise<Array<WorkflowExecution>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflow_executions/by_workflow/{workflow_id}',
            path: {
                'workflow_id': workflowId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Workflow Executions By Workflow Data
     * @param workflowDataId
     * @returns WorkflowExecution Successful Response
     * @throws ApiError
     */
    public static getWorkflowExecutionsByWorkflowData(
        workflowDataId: string,
    ): CancelablePromise<Array<WorkflowExecution>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflow_executions/by_workflow_data/{workflow_data_id}',
            path: {
                'workflow_data_id': workflowDataId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Workflow Execution
     * @param workflowExecutionId
     * @param requestBody
     * @returns WorkflowExecution Successful Response
     * @throws ApiError
     */
    public static updateWorkflowExecution(
        workflowExecutionId: string,
        requestBody: WorkflowExecutionUpdate,
    ): CancelablePromise<WorkflowExecution> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow_executions/update/{workflow_execution_id}',
            path: {
                'workflow_execution_id': workflowExecutionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Workflow Execution
     * @param workflowExecutionId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteWorkflowExecution(
        workflowExecutionId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflow_executions/delete/{workflow_execution_id}',
            path: {
                'workflow_execution_id': workflowExecutionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Activity
     * Get a specific activity by ID.
     * @param activityId
     * @returns Activity Successful Response
     * @throws ApiError
     */
    public static getActivity(
        activityId: string,
    ): CancelablePromise<Activity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/activities/{activity_id}',
            path: {
                'activity_id': activityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Activities By Org Paginate
     * Get paginated activities for an organization with filters.
     * @param requestBody
     * @param page Page number
     * @param size Page size
     * @returns Page_Activity_ Successful Response
     * @throws ApiError
     */
    public static getActivitiesByOrgPaginate(
        requestBody: Record<string, any>,
        page: number = 1,
        size: number = 50,
    ): CancelablePromise<Page_Activity_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/activities/by_org_paginate/',
            query: {
                'page': page,
                'size': size,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Activities By Org
     * Get all activities for an organization with optional filters.
     * @param requestBody
     * @returns Activity Successful Response
     * @throws ApiError
     */
    public static getActivitiesByOrg(
        requestBody?: (Record<string, any> | null),
    ): CancelablePromise<Array<Activity>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/activities/by_org/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Activity
     * Update an activity.
     * @param activityId
     * @param requestBody
     * @returns Activity Successful Response
     * @throws ApiError
     */
    public static updateActivity(
        activityId: string,
        requestBody: ActivityUpdate,
    ): CancelablePromise<Activity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/activities/update/{activity_id}',
            path: {
                'activity_id': activityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Activity
     * Delete an activity.
     * @param activityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteActivity(
        activityId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/activities/delete/{activity_id}',
            path: {
                'activity_id': activityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Projects
     * Get all projects for the organization.
     * @returns Project Successful Response
     * @throws ApiError
     */
    public static getProjects(): CancelablePromise<Array<Project>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/projects',
        });
    }
    /**
     * Create Project
     * Create a new project.
     * @param requestBody
     * @returns Project Successful Response
     * @throws ApiError
     */
    public static createProject(
        requestBody: ProjectCreate,
    ): CancelablePromise<Project> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/projects',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Project
     * Get a project by ID.
     * @param projectId
     * @returns Project Successful Response
     * @throws ApiError
     */
    public static getProject(
        projectId: string,
    ): CancelablePromise<Project> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/projects/{project_id}',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Project
     * Update a project.
     * @param projectId
     * @param requestBody
     * @returns Project Successful Response
     * @throws ApiError
     */
    public static updateProject(
        projectId: string,
        requestBody: ProjectCreate,
    ): CancelablePromise<Project> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/projects/projects/{project_id}',
            path: {
                'project_id': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Project
     * Delete a project.
     * @param projectId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteProject(
        projectId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/projects/projects/{project_id}',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Research
     * @param projectId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static research(
        projectId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/research',
            query: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Keywords
     * @param projectId
     * @returns Keywords Successful Response
     * @throws ApiError
     */
    public static generateKeywords(
        projectId: string,
    ): CancelablePromise<Keywords> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/generate_keywords',
            query: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Request
     * Create a new request.
     * @param requestBody
     * @returns Request Successful Response
     * @throws ApiError
     */
    public static createRequest(
        requestBody: RequestCreate,
    ): CancelablePromise<Request> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/requests',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Requests
     * Get all requests for a project.
     * @param projectId
     * @returns Request Successful Response
     * @throws ApiError
     */
    public static getRequests(
        projectId: string,
    ): CancelablePromise<Array<Request>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/requests',
            query: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Requests With Latest Responses
     * Get all requests for a project with their latest response summaries.
     * @param projectId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getRequestsWithLatestResponses(
        projectId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/requests/with-latest-responses',
            query: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Request
     * Get a request by ID.
     * @param requestId
     * @returns Request Successful Response
     * @throws ApiError
     */
    public static getRequest(
        requestId: string,
    ): CancelablePromise<Request> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/requests/{request_id}',
            path: {
                'request_id': requestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Request
     * Delete a request.
     * @param requestId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteRequest(
        requestId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/requests/{request_id}',
            path: {
                'request_id': requestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Response
     * Create a new response.
     * @param requestBody
     * @returns Response Successful Response
     * @throws ApiError
     */
    public static createResponse(
        requestBody: ResponseCreate,
    ): CancelablePromise<Response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/responses',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Responses
     * Get all responses for a project.
     * @param projectId
     * @returns Response Successful Response
     * @throws ApiError
     */
    public static getResponses(
        projectId: string,
    ): CancelablePromise<Array<Response>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/responses',
            query: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Responses By Request
     * Get all responses for a request string.
     * @param request
     * @returns Response Successful Response
     * @throws ApiError
     */
    public static getResponsesByRequest(
        request: string,
    ): CancelablePromise<Array<Response>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/responses/by_request/{request}',
            path: {
                'request': request,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Response
     * Get a response by ID.
     * @param responseId
     * @returns Response Successful Response
     * @throws ApiError
     */
    public static getResponse(
        responseId: string,
    ): CancelablePromise<Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/responses/{response_id}',
            path: {
                'response_id': responseId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Response
     * Delete a response.
     * @param responseId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteResponse(
        responseId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/responses/{response_id}',
            path: {
                'response_id': responseId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Run Request
     * Run a request and create a response.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static runRequest(
        requestBody: RunRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/requests/run',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Responses Chart Data
     * Get chart data for responses to a request string.
     * @param request
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getResponsesChartData(
        request: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/responses/chart-data/{request}',
            path: {
                'request': request,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Table Metadata
     * @returns TableMetadata Successful Response
     * @throws ApiError
     */
    public static getAllTableMetadata(): CancelablePromise<Array<TableMetadata>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/table_metadata/',
        });
    }
    /**
     * Create Table Metadata
     * @param requestBody
     * @returns TableMetadata Successful Response
     * @throws ApiError
     */
    public static createTableMetadata(
        requestBody: TableMetadataCreate,
    ): CancelablePromise<TableMetadata> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/table_metadata/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Table Metadata
     * @param tableMetadataId
     * @returns TableMetadata Successful Response
     * @throws ApiError
     */
    public static getTableMetadata(
        tableMetadataId: string,
    ): CancelablePromise<TableMetadata> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/table_metadata/{table_metadata_id}',
            path: {
                'table_metadata_id': tableMetadataId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Table Metadata
     * @param tableMetadataId
     * @param requestBody
     * @returns TableMetadata Successful Response
     * @throws ApiError
     */
    public static updateTableMetadata(
        tableMetadataId: string,
        requestBody: TableMetadataUpdate,
    ): CancelablePromise<TableMetadata> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/table_metadata/update/{table_metadata_id}',
            path: {
                'table_metadata_id': tableMetadataId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Table Metadata
     * @param tableMetadataId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteTableMetadata(
        tableMetadataId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/table_metadata/delete/{table_metadata_id}',
            path: {
                'table_metadata_id': tableMetadataId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Table From Request
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createTableFromRequest(
        requestBody: CreateTableFromRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/table_metadata/create_from_request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pull Data From Web
     * @param tableMetadataId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static pullDataFromWeb(
        tableMetadataId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/table_metadata/pull_data_from_web',
            query: {
                'table_metadata_id': tableMetadataId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pull Data From Web Perplexity
     * @param tableMetadataId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static pullDataFromWebPerplexity(
        tableMetadataId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/table_metadata/pull_data_from_web_perplexity',
            query: {
                'table_metadata_id': tableMetadataId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Table Data
     * @param requestBody
     * @returns TableData Successful Response
     * @throws ApiError
     */
    public static createTableData(
        requestBody: TableDataCreate,
    ): CancelablePromise<TableData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/table_data/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Table Data
     * @param tableDataId
     * @returns TableData Successful Response
     * @throws ApiError
     */
    public static getTableData(
        tableDataId: string,
    ): CancelablePromise<TableData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/table_data/{table_data_id}',
            path: {
                'table_data_id': tableDataId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Table Data By Metadata
     * @param tableMetadataId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getTableDataByMetadata(
        tableMetadataId: string,
    ): CancelablePromise<Array<Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/table_data/by_metadata/{table_metadata_id}',
            path: {
                'table_metadata_id': tableMetadataId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Table Data
     * @param tableDataId
     * @param requestBody
     * @returns TableData Successful Response
     * @throws ApiError
     */
    public static updateTableData(
        tableDataId: string,
        requestBody: TableDataUpdate,
    ): CancelablePromise<TableData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/table_data/update/{table_data_id}',
            path: {
                'table_data_id': tableDataId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Table Data Field
     * @param tableDataId
     * @param fieldName
     * @param fieldValue
     * @returns TableData Successful Response
     * @throws ApiError
     */
    public static updateTableDataField(
        tableDataId: string,
        fieldName: string,
        fieldValue: string,
    ): CancelablePromise<TableData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/table_data/update_field/{table_data_id}',
            path: {
                'table_data_id': tableDataId,
            },
            query: {
                'field_name': fieldName,
                'field_value': fieldValue,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Table Data
     * @param tableDataId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteTableData(
        tableDataId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/table_data/delete/{table_data_id}',
            path: {
                'table_data_id': tableDataId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Favicon
     * Proxy favicon requests from DuckDuckGo's icon service.
     * @param url
     * @returns any Successful Response
     * @throws ApiError
     */
    public static favicon(
        url: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/proxy/favicon',
            query: {
                'url': url,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Health Check
     * @returns any Successful Response
     * @throws ApiError
     */
    public static healthCheck(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health_check',
        });
    }
    /**
     * Health Check Unsecured
     * @returns any Successful Response
     * @throws ApiError
     */
    public static healthCheckUnsecured(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health_unsecured',
        });
    }
    /**
     * Root
     * @returns any Successful Response
     * @throws ApiError
     */
    public static root(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/',
        });
    }
}
